import { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from '@/components/Text';
import { CheckBox, Divider } from 'react-native-elements';
import { Icon } from '@/components/Icon';
import colors, { appTheme } from '@/config/colors';
import store from '../../stores/store';
import { Modal } from '@/components/ui/therapist/Modal';
import { Button } from '@/components/ui/therapist/Button';

const styles = StyleSheet.create({
  setName: {
    color: colors.darkGrey,
    fontSize: 14,
  },
  selfTrainingName: {
    fontSize: 18,
    fontWeight: '700',
  },

  box: {
    backgroundColor: colors.newUI.therapist.bgBlue10,
    borderRadius: 8,
  },
  checkbox: {
    alignSelf: 'center',
  },

  heading: {
    fontSize: 20,
    fontWeight: '600',
    padding: 12,
    paddingBottom: 8,
  },
});

const SetCard = ({ item, onPress }) => (
  <View style={[styles.box]}>
    <View style={{ flexDirection: 'row' }}>
      <View style={{ flex: 1, padding: 16 }}>
        <Text style={styles.selfTrainingName}>{item.appDisplayName ?? ''}</Text>
        <Text style={styles.setName} numberOfLines={1}>
          ({item.name})
        </Text>
      </View>
      <View style={[styles.checkbox]}>
        <CheckBox
          checked={item.selected}
          onPress={onPress}
          checkedColor={appTheme.primary}
        />
      </View>
    </View>
  </View>
);

export function ActiveSets() {
  const [wordSets, setWordSets] = useState([]);
  const [sentenceSets, setSentenceSets] = useState([]);
  const [textSets, setTextSets] = useState([]);
  const [isSelectExceeded, setIsSelectExceeded] = useState(false);

  const numberOfAvailableSets = [...wordSets, ...sentenceSets, ...textSets]
    .length;

  const numberOfSelectedSets =
    store.getState().patient.activeTextsets.length +
    store.getState().patient.activeSentencesets.length +
    store.getState().patient.activeWordsets.length;

  //words
  useEffect(() => {
    let words = store.getState().patient.wordsets.map((item) => {
      item.appDisplayName ??= 'Wörter';
      let newval = item;
      let bool = false;
      let removed = store
        .getState()
        .patient.activeWordsets.filter((data) => data == item._id);
      if (removed == item._id) bool = true;

      newval.selected = bool;
      return newval;
    });

    setWordSets(words);
  }, []);

  const onWordValueChange = (item) => {
    const newWord = wordSets.map((newItem) => {
      if (newItem._id == item._id && item.selected == true) {
        let removed = store
          .getState()
          .patient.activeWordsets.filter((data) => data != item._id);
        store.getState().patient.activeWordsets = removed;
        if (store.getState().patient?.activeWordsets.length > 0) {
          store.getState().patient.activeWordset =
            store.getState().patient?.activeWordsets[0];
        } else {
          store.getState().patient.activeWordset = null;
        }
        return { ...newItem, selected: false };
      }
      if (newItem._id == item._id && item.selected == false) {
        if (numberOfSelectedSets === 4) {
          setIsSelectExceeded(true);
          return { ...newItem };
        } else {
          store.getState().patient.activeWordsets.push(item._id);
          store.getState().patient.activeWordset = item._id;
          return { ...newItem, selected: true };
        }
      }
      return { ...newItem };
    });

    setWordSets(newWord);
  };

  //sentence
  useEffect(() => {
    let sentences = store.getState().patient.sentencesets.map((item) => {
      item.appDisplayName ??= 'Sätze';
      let newval = item;
      let bool = false;

      let removed = store
        .getState()
        .patient.activeSentencesets.filter((data) => data == item._id);
      if (removed == item._id) bool = true;

      newval.selected = bool;
      return newval;
    });
    setSentenceSets(sentences);
  }, []);

  const onSentenceValueChange = (item) => {
    const newWord = sentenceSets.map((newItem) => {
      if (newItem._id == item._id && item.selected == true) {
        let removed = store
          .getState()
          .patient.activeSentencesets.filter((data) => data != item._id);
        store.getState().patient.activeSentencesets = removed;
        if (store.getState().patient?.activeSentencesets.length > 0) {
          store.getState().patient.activeSentenceset =
            store.getState().patient?.activeSentencesets[0];
        } else {
          store.getState().patient.activeSentenceset = null;
        }
        return { ...newItem, selected: false };
      }
      if (newItem._id == item._id && item.selected == false) {
        if (numberOfSelectedSets === 4) {
          setIsSelectExceeded(true);
          return { ...newItem };
        } else {
          store.getState().patient.activeSentencesets.push(item._id);
          store.getState().patient.activeSentenceset = item._id;
          return { ...newItem, selected: true };
        }
      }
      return { ...newItem };
    });

    setSentenceSets(newWord);
  };

  //text
  useEffect(() => {
    let texts = store.getState().patient.textsets.map((item) => {
      item.appDisplayName ??= 'Texte';
      let newval = item;
      let bool = false;
      let removed = store
        .getState()
        .patient.activeTextsets.filter((data) => data == item._id);
      if (removed == item._id) bool = true;

      newval.selected = bool;
      return newval;
    });
    setTextSets(texts);
  }, []);

  const onTextValueChange = (item) => {
    const newWord = textSets.map((newItem) => {
      if (newItem._id == item._id && item.selected == true) {
        let removed = store
          .getState()
          .patient.activeTextsets.filter((data) => data != item._id);
        store.getState().patient.activeTextsets = removed;
        if (store.getState().patient?.activeTextsets.length > 0) {
          store.getState().patient.activeTextset =
            store.getState().patient?.activeTextsets[0];
        } else {
          store.getState().patient.activeTextset = null;
        }
        return { ...newItem, selected: false };
      }
      if (newItem._id == item._id && item.selected == false) {
        if (numberOfSelectedSets === 4) {
          setIsSelectExceeded(true);
          return { ...newItem };
        } else {
          store.getState().patient.activeTextsets.push(item._id);
          store.getState().patient.activeTextset = item._id;
          return { ...newItem, selected: true };
        }
      }
      return { ...newItem };
    });

    setTextSets(newWord);
  };

  return (
    <View>
      <Modal
        isVisible={isSelectExceeded}
        onClose={() => setIsSelectExceeded(false)}
        title="Limit erreicht"
        confirmActionButton={
          <Button
            label="OK"
            onPress={() => {
              setIsSelectExceeded(false);
            }}
          />
        }
      >
        <Text style={{ fontSize: 20 }}>
          Es können maximal vier Übungssets gleichzeitig aktiviert werden.
          Deaktivieren Sie ein Set, um ein neues Set zu aktivieren.
        </Text>
      </Modal>

      <Text style={{ fontSize: 18, paddingBottom: 16 }}>
        <Text>Aktive Übungssets: </Text>
        {numberOfSelectedSets > 0 && (
          <Text style={{ fontWeight: '600' }}>
            {numberOfSelectedSets} von 4 Sets ausgewählt
          </Text>
        )}
        {numberOfSelectedSets === 0 && numberOfAvailableSets > 0 && (
          <Text style={{ color: colors.red, fontWeight: '600' }}>
            <Icon name="alertCircle" size={18} /> Mindestens ein Set auswählen
          </Text>
        )}
        {numberOfSelectedSets === 0 && numberOfAvailableSets === 0 && (
          <Text style={{ fontWeight: '600' }}>
            Es stehen noch keine Sets zur Auswahl. Erstellen Sie zuerst ein Set
          </Text>
        )}
      </Text>
      {numberOfAvailableSets > 0 && (
        <>
          <Divider color={colors.grey} width={2} />
          <Text style={{ paddingVertical: 16 }}>
            Welche Übungssets sollen im Eigentraining verwendet werden? Sie
            können zwischen 1-4 Sets aktivieren.
          </Text>
          <View
            style={{
              flexDirection: 'row',
              paddingBottom: 16,
              gap: 16,
            }}
          >
            <View style={{ flex: 1 }}>
              <Text style={styles.heading}>Wörtersets</Text>
              <View style={{ gap: 16 }}>
                {wordSets.map((item) => (
                  <SetCard
                    key={item._id}
                    item={item}
                    onPress={() => onWordValueChange(item)}
                  />
                ))}
              </View>
            </View>
            <View style={{ flex: 1 }}>
              <Text style={styles.heading}>Sätzesets</Text>
              <View style={{ gap: 16 }}>
                {sentenceSets.map((item) => (
                  <SetCard
                    key={item._id}
                    item={item}
                    onPress={() => onSentenceValueChange(item)}
                  />
                ))}
              </View>
            </View>
            <View style={{ flex: 1 }}>
              <Text style={styles.heading}>Textesets</Text>
              <View style={{ gap: 16 }}>
                {textSets.map((item) => (
                  <SetCard
                    key={item._id}
                    item={item}
                    onPress={() => onTextValueChange(item)}
                  />
                ))}
              </View>
            </View>
          </View>
        </>
      )}
    </View>
  );
}
